import apiDB from './api_db';

let controller = new apiDB({
    api_module: 'controller',
    table_key_name: 'controller_id',
    reducer_name: 'controllerR',
    reducer_var: 'controller',
    action_prefix: 'CONTROLLER'});

export default controller;